import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import zeplinColor from '../../../../theme/Color';
import { Utilities } from '../../../../utilities/utilities';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import CustomHomepage from '../../../shared/CustomHomePage/CustomHomepage';
import Companies from './Companies';
import Employees from './Employees';
import News from './News';
import ZoominfoOverview from './Overview';
import styles from './styles.module.css';

const BusinessSelected = () => {
  const theme = useTheme();
  const location = useLocation();
  const [dataDetails, setDataDetails] = useState<any>({});
  const [exportLoading, setExportLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };

  const exportData = async (id: string) => {
    try {
      setExportLoading(true);
      const res = await ZoomInfoService.exportCompanyData(id);
      Utilities.downloadCSV(res, dataDetails?.name || 'company');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setExportLoading(false);
    }
  };

  const getDetails = async (id: string) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getCompanyDetails(id);
      setDataDetails(res);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(
      `https://app.zoominfo.com/#/apps/profile/company/${dataDetails?.item?.id}/overview`,
    );
    setAlert(`Link copied successfully`);
  };
  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <ZoominfoOverview data={dataDetails} setValue={setValue} />
        </Box>
      ),
    },
    {
      label: 'Employees',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <Employees />
        </Box>
      ),
    },
    {
      label: 'News',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <News />
        </Box>
      ),
    },
    {
      label: 'Similar Companies',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <Companies data={dataDetails?.item?.competitors} loading={loading} />
        </Box>
      ),
    },
  ];

  useEffect(() => {
    getDetails(location?.pathname.split('/')[2] || '');
  }, [location?.pathname.split('/')[2]]);

  return (
    <>
      <CustomHomepage
        CTA={
          <Link
            to={'https://login.zoominfo.com/'}
            style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <CustomCard
              styles={{
                borderRadius: '50px',
                padding: { xs: '8px 8px 8px 14px', xl: '10px 10px 10px 16px' },
                backgroundColor: zeplinColor.Neutral1,
                border: `1px solid ${zeplinColor.Neutral6}`,
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
              }}
            >
              <Typography variant='responsiveBody3'>ZoomInfo</Typography>
              <img src='/assets/link-2.svg' className={styles['zoomLink']} />
            </CustomCard>
          </Link>
        }
        sportsData={[]}
        ProfileDetails={
          <Box
            sx={{ display: 'flex', gap: '24px', padding: '10px', flexDirection: 'column', flex: 1 }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', gap: '16px' }}>
                {loading ? (
                  <Skeleton
                    variant='rounded'
                    width={60}
                    height={60}
                    sx={{ backgroundColor: zeplinColor.Neutral4 }}
                  />
                ) : (
                  <img
                    src={dataDetails?.item?.logo || ''}
                    alt='logo'
                    loading='lazy'
                    style={{
                      objectFit: 'contain',
                      borderRadius: '8px',
                      backgroundColor: zeplinColor.Neutral1,
                      width: '60px',
                      height: '60px',
                    }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                    }}
                  />
                )}
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                >
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        width: '5rem',
                        backgroundColor: zeplinColor.Neutral4,
                      }}
                    />
                  ) : (
                    <Typography variant='responsiveHeading1' color={zeplinColor.Neutral1}>
                      {dataDetails?.item?.name}
                    </Typography>
                  )}
                  <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', gap: '4px' }}>
                      <img
                        src={'/assets/zoominfo-website.svg'}
                        alt='website'
                        loading='lazy'
                        style={{ width: '20px', height: '20px' }}
                      />
                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            width: '5rem',
                            backgroundColor: zeplinColor.Neutral4,
                          }}
                        />
                      ) : (
                        <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                          {dataDetails?.item?.website}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: '12px' }}>
                <Box
                  sx={{
                    padding: '6px 16px',
                    borderRadius: '8px',
                    border: `1px solid ${zeplinColor.Neutral1}`,
                    display: 'flex',
                    gap: '8px',
                    width: 'auto',

                    alignItems: 'center',
                    height: '32px',
                  }}
                  onClick={handleCopyLink}
                >
                  <img
                    src={'/assets/copy-white.svg'}
                    alt='logo'
                    loading='lazy'
                    style={{ width: '20px', height: '20px', display: 'block', margin: 'auto' }}
                  />
                  <Typography variant='responsiveButtonSmall' color={zeplinColor.Neutral1}>
                    Copy Link
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: '6px 16px',
                    borderRadius: '8px',
                    display: 'flex',
                    gap: '8px',
                    width: 'auto',
                    backgroundColor: exportLoading ? zeplinColor.Neutral4 : zeplinColor.Brand1,
                    alignItems: 'center',
                    height: '32px',
                  }}
                  onClick={() => {
                    !exportLoading && exportData(location?.pathname.split('/')[2]);
                  }}
                >
                  <Typography
                    variant='responsiveButtonSmall'
                    color={exportLoading ? zeplinColor.BasicBlack : zeplinColor.Neutral1}
                  >
                    {exportLoading ? 'Exporting...' : 'Export'}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <img
                  src={'/assets/zoominfo-location.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.street}
                    {`${dataDetails?.item?.street ? ', ' : ''}`}
                    {dataDetails?.item?.city}
                    {`${dataDetails?.item?.city ? ', ' : ''}`}
                    {dataDetails?.item?.zipCode}
                    {`${dataDetails?.item?.zipCode ? ', ' : ''}`}
                    {dataDetails?.item?.country}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px',
                }}
              />

              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-industry.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.industries?.join(',')}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px',
                }}
              />
              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-employee.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.employeeCount} Employees
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: zeplinColor.Neutral9,
                  display: 'inline-block',
                  marginX: '4px', // Add some margin on both sides
                }}
              />
              <Box sx={{ display: 'flex', gap: '8px' }}>
                <img
                  src={'/assets/zoominfo-dollar.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '5rem',
                      backgroundColor: zeplinColor.Neutral4,
                    }}
                  />
                ) : (
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                    {dataDetails?.item?.revenueRange}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        }
        DealCard={<Box />}
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={''}
      />
    </>
  );
};

export default BusinessSelected;
